import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { AuthFacade } from 'src/app/services/facades/auth/auth.facade';
import { FirebaseAuthService } from 'src/app/services/firebase/firebase-auth.service';
import { NURSE_CONTEXT } from './nurse-context';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthFacade,
    private firebaseAuth: FirebaseAuthService,
  ) {}

  attachHeaders(req: HttpRequest<any>, token: string = ''): HttpRequest<any> {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      },
      withCredentials: true
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(NURSE_CONTEXT)) {
      return next.handle(req);
    }
    return this.firebaseAuth.token$.pipe(
      take(1),
      switchMap(token => {
        req = this.attachHeaders(req, token || '');
        return next.handle(req).pipe(
          catchError(e => {
            if (e instanceof HttpErrorResponse && e.status === 401 && token) {
              return from(this.firebaseAuth.getIdToken(true)).pipe(
                switchMap(freshToken => {
                  if (freshToken) {
                    req = this.attachHeaders(req, freshToken);
                    return next.handle(req);
                  }
                  this.auth.logout();
                  return throwError(e);
                }),
                catchError(() => {
                  this.auth.logout();
                  return throwError(e);
                })
              );
            }
            return throwError(e);
          })
        );
      })
    );
  }
}
